<h1 class="h2 guts-p-full-2">{{ 'Opportunities_Mentors' | translate }}</h1>
<dgx-data-table
  propTrackingKey="userProfileId"
  [columns]="mentorColumns"
  [isLoading]="isLoading"
  [isSorting]="isSorting"
  [useSkeleton]="true"
  [numResultsPerPage]="5"
  [items]="mentors"
  [menuSettings]="menuSettings"
></dgx-data-table>

<ng-template #contactBy let-mentor>
  {{ mentor | mentoringContact }}
</ng-template>

<ng-template #status let-mentor>
  <span
    class="badge badge-pill badge-{{ (mentor | mentoringBadge).pillClass }}"
  >
    {{ (mentor | mentoringBadge: mentorshipType).pillLabel | translate }}
  </span>
</ng-template>
